<template>
  <h1>Trang giới thiệu đang được phát triển</h1>
</template>

<script>
export default {
  name: "About"
}
</script>

<style scoped>

</style>
